import React, { useMemo } from "react";
import { FaChevronRight } from "react-icons/fa";
import './breadcrumb.css';
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

/* const routeNames = {
  'servicios': 'Servicios',
  'nacionales': 'Nacionales',
  'gold': 'Gold',
  'standar': 'Standar',
  'perishable-goods': 'Perecederos',
  'high-technology': 'Alta Tecnología'
}; */

function BreadCrumb () {
    const location = useLocation();
    const { t } = useTranslation("navbarRedesign");

    // 2. Creamos el "Diccionario Dinámico" usando useMemo.
    const routeNames = useMemo(() => {
        // Obtenemos los objetos completos del JSON
        const urlsObj = t("urls", { returnObjects: true });
        const labelsObj = t("labels", { returnObjects: true });

        // Objeto donde guardaremos: { "alta-tecnologia": "Alta Tecnología", "nacionales": "Nacionales" ... }
        const map = {};

        // Función recursiva para recorrer tus objetos anidados (como 'specialized')
        const traverseAndMap = (urls, labels) => {
            if (!urls || !labels) return;

            Object.keys(urls).forEach(key => {
                const urlValue = urls[key];
                const labelValue = labels[key];

                if (typeof urlValue === 'string') {
                    // Tomamos solo lo que está después de la última barra '/'
                    const segment = urlValue.split('/').pop(); 
                    
                    // Guardamos en el mapa: map["alta-tecnologia"] = "Alta Tecnología"
                    if (segment && labelValue && typeof labelValue === 'string') {
                        map[segment] = labelValue;
                    }
                } else if (typeof urlValue === 'object') {
                    // Si hay niveles más profundos (como 'specialized' o 'national'), llamamos a la función de nuevo bajando un nivel.
                    traverseAndMap(urlValue, labelValue);
                }
            });
        };

        // Ejecutamos la función con tus datos
        traverseAndMap(urlsObj, labelsObj);
        
        return map;
    }, [t]); // Se ejecuta solo cuando cambia la función 't' (cambio de idioma)

    // 2. Obtenemos las partes de la URL.
    // Si la URL es "/servicios/nacionales/gold", esto crea: ['servicios', 'nacionales', 'gold']
    const pathnames = location.pathname.split('/').filter((x) => x);

    const formatSegmentLabel = (segment) => {
        return String(segment || "")
            .replace(/[-_]+/g, " ")
            .trim()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    // Si estamos en home o la ruta está vacía, no mostramos nada
    if (pathnames.length === 0) return null;

    return(
        <>
            <div className="container-fluid breadcrumb-container">
                <div className="row">
                    <div className="col breadcrumb-list">
                        {/* Mapeamos cada pedacito de la URL */}
                        {pathnames.map((value, index) => {
                            // Construimos la ruta acumulada. 
                            // Si vamos en 'nacionales', el 'routeTo' será "/servicios/nacionales"
                            const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                            
                            // Verificamos si es el último elemento (la página actual)
                            const isLast = index === pathnames.length - 1;

                            // Obtenemos el nombre bonito del diccionario. Si no existe, usamos el valor de la URL
                            const displayName = routeNames[value] || formatSegmentLabel(value);

                            return (
                                <span key={routeTo} className="breadcrumb-item-wrapper">
                                    {/* Agregamos la flechita ANTES del item, excepto si es el primero */}
                                    {index > 0 && <FaChevronRight className="breadcrumb-separator" />}

                                    {isLast ? (
                                        // 3. Si es el último, es TEXTO color Rosa Mexicano (no clickeable)
                                        <span className="breadcrumb-active">
                                            {displayName}
                                        </span>
                                    ) : (
                                        // 4. Si NO es el último, es un LINK hacia esa ruta
                                        <Link to={routeTo} className="breadcrumb-link">
                                            {displayName}
                                        </Link>
                                    )}
                                </span>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
}

export default BreadCrumb;